import { Form, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
// Import do CSS
import 'primeicons/primeicons.css';
import "bootstrap-icons/font/bootstrap-icons.css";

// Import dos contextos
import { useAppContext } from "../../../../../context/AppContext";
import { useWebsite } from "../Context/WebSiteContext";

// Imports dos components
import SidebarConfig from "./Components/Sidebarconfig";



import NavbarModern from "./Components/TemplateModern/NavbarModern";
import HeroModern from "./Components/TemplateModern/HeroModern";
import GalleryModern from "./Components/TemplateModern/GalleryModern";
import AboutModern from "./Components/TemplateModern/AboutModern";
import StatusModern from "./Components/TemplateModern/StatusModern";
import FormModern from "./Components/TemplateModern/FormModern";
import FooterModern from "./Components/TemplateModern/FooterModern";
import BannerConfirm from "./Components/BannerConfirm";
import BannerPreview from "./Components/BannerPreview";


const TemplateModern = ({ config, hideSidebar }) => {
  const { id } = useParams();
  const context = useAppContext();

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
  }, [context]);
  const { formData, handlePublish, handleCancel } = useWebsite();


  if (!config) return <div>Configurações não carregadas</div>;
  const mergedConfig = { ...config, ...formData };

  const finalOrderedSections = Array.isArray(formData?.orderedSections)
    ? formData.orderedSections
    : Array.isArray(formData?.orderedsections)
      ? formData.orderedsections
      : Array.isArray(config.orderedSections)
        ? config.orderedSections
        : config.orderedsections;

  function isSectionActive(sectionName) {
    const normalize = (str) => (str || "").toString().toLowerCase().replace(/[áãâàéêíóôõúç]/g, s =>
      ({á:'a',ã:'a',â:'a',à:'a',é:'e',ê:'e',í:'i',ó:'o',ô:'o',õ:'o',ú:'u',ç:'c'})[s] || s
    );
    const sectionKeys = [
      sectionName,
      sectionName.toLowerCase(),
      sectionName.toUpperCase(),
      normalize(sectionName),
      normalize(sectionName).charAt(0).toUpperCase() + normalize(sectionName).slice(1)
    ];

    const sectionsFormData = formData.sections || formData.Sections || {};
    const sectionsConfig = config.sections || config.Sections || {};

    for (const key of sectionKeys) {
      if (sectionsFormData.hasOwnProperty(key)) return !!sectionsFormData[key];
      if (sectionsConfig.hasOwnProperty(key)) return !!sectionsConfig[key];
    }

    // Garantir que 'statusObra' seja reconhecido como 'Status'
    if (sectionName === 'Status' && (formData.statusObra || config.statusObra)) {
      return true;
    }

    return false;
  }

  return (
    <div className="template-modern">
      {!hideSidebar && <SidebarConfig />}
      {!hideSidebar && <BannerConfirm />}
      {hideSidebar && <BannerPreview onEdit={() => window.location.href = `/template/${id}`} />}
      {Array.isArray(finalOrderedSections) &&
        finalOrderedSections.map((sectionName, index) => {
          const sectionMap = {
            'Cabeçalho': ['cabecalho', 'header'],
            'Menu': ['menu', 'navbar'],
            'Galeria': ['galeria'],
            'Sobre': ['sobre', 'sobreNos'],
            'Formulario': ['formulario'],
            'Status': ['statusObra', 'status'],
            'Rodapé': ['rodape', 'footer']
          };

          if (!isSectionActive(sectionName)) return null;

          const possibleKeys = sectionMap[sectionName] || [];
          const sectionKey = possibleKeys.find(key => key in mergedConfig);

          if (!sectionKey) {
            return null;
          }

          switch (sectionKey) {
            case 'menu':
            case 'navbar':
              return <NavbarModern key={index} config={mergedConfig} />;
            case 'cabecalho':
            case 'header':
              return <HeroModern key={index} config={mergedConfig} />;
            case 'galeria':
              return <GalleryModern key={index} config={mergedConfig} />;
            case 'sobre':
            case 'sobreNos':
              return <AboutModern key={index} config={mergedConfig} />;
            case 'statusObra':
            case 'status':
              return <StatusModern key={index} config={mergedConfig} />;
            case 'formulario':
              return (
                <FormModern
                  key={index}
                  formulario={mergedConfig.formulario}
                  primaryColor={mergedConfig.primaryColor}
                  secondaryColor={mergedConfig.secondaryColor}
                />
              );
            case 'rodape':
            case 'footer':
              return (
                <FooterModern
                  key={index}
                  config={mergedConfig}
                  primaryColor={mergedConfig.primaryColor}
                  secondaryColor={mergedConfig.secondaryColor}
                />
              );
            default:
              return null;
          }
        })}
    </div>
  )

}

export default TemplateModern;